import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import ProductDataFilter from "../../../components/product-data-filter/product-data-filter";
import GenericDataChart from "../../../GenericPageElements/GenericDataChart";
import GenericPageContainer from "../../../GenericPageElements/GenericPageContainer";
import GenericProductFilterContainer from "../../../GenericPageElements/GenericProductFilterContainer";
import hasPermission from '../../../helpers/permissions';
import request from "../../../helpers/request";
import S3Modal from "../../../components/s3Modal/S3Modal";
import endpoints from "../../../helpers/endpoints";
import GenericDataRow from "../../../GenericPageElements/GenericDataRow";
import Text from 'recharts/lib/component/Text';
import { view } from "@risingstack/react-easy-state";
import { Link } from "react-router-dom";
import BulkBuy from '../../../components/cot-alert-bulk-buy/bulkBuy';
import BulkAllocate from '../../../components/cot-alert-bulk-allocate/bulkAllocate';

export default view(function Undeliverable() {
    const [filters, setFilters] = useState({});
    const [selectedGroupBy, setSelectectGroupBy] = useState("Connection_Type");
    const [data, setData] = useState(null);
    const [dates, setDates] = useState([]);
    const [date, setDate] = useState(null);
    const [S3Model, setS3Model] = useState(null);
    const [bulkModel, setBulkModel] = useState('')

    const CustomizedAxisTickMultiLine = ({x, y, payload}) => {
      return (
         <Text x={x} y={y} width={100} textAnchor="middle" verticalAnchor="start">{payload.value}</Text>
      )
    };

    const applyFilter = (column, value) => {
        setFilters((current) => {
            return {
                ...current,
                [column]: value,
            };
        });
    };

    useEffect(() => {
        request(true)
            .get(endpoints.UNDELIVERABLE_DATES)
            .then((e) => {
                setDates(e.data.dates);
                if (e.data.dates.length > 0) setDate("All_Refreshes");
            });
    }, []);

    useEffect(() => {
        if (!date) return;
        request(true)
            .get(endpoints.UNDELIVERABLE_DATA, {
                doesCancel: true,
                params: {
                    date: date,
                    filter: filters,
                    group: selectedGroupBy,
                },
            })
            .then((e) => {
                setData(e.data);
            });
    }, [filters, selectedGroupBy, date]);

    return [
        <GenericPageContainer
        title="Non-Addressable - Summary"
        titleIconClass={"fak fa-id-business-icon fa-2x colour-primary"}
        titleRight={
          <div>
            <Link className="navigate" to="/portal/undeliverable/search">
                To Search
            </Link>
            { (hasPermission('UNDELIVERABLE', 'WORKFLOW')) ?
              <Link className="navigate" to="/portal/undeliverable/workflow">
                  To Workflow
              </Link>
            : null }
            {hasPermission('UNDELIVERABLE', 'DOWNLOAD') ? (
              <button className="navigate" onClick={() => setS3Model("download")}>
                Download Return File
              </button>
            ) : null}
          </div>
        }
      >
        <div style={{maxWidth: '20vw', marginBottom: 15}}>
        <GenericDataRow title={"File Date"} contentColour={"white"}>
          <select
            onChange={(_) => setDate(_.target.value)}
            value={date}
            style={{
              width: "100%",
              height: "100%",
              border: "none",
              backgroundColor: "white",
              paddingLeft: "10px",
            }}
          >
            <option key={"All_Refreshes"} value={"All_Refreshes"}>All Refreshes</option>
            {dates.map((item) => {
              return (
                <option key={item.raw} value={item.raw}>
                  {item.pretty}
                </option>
              );
            })}
          </select>
        </GenericDataRow>
        </div>
        <div className='HP'>
          <GenericDataChart
            dataReady={!!data}
            data={data}
            selectedGroupBy={selectedGroupBy}
            setSelectectGroupBy={setSelectectGroupBy}
            groupingsEndpoint={endpoints.UNDELIVERABLE_GROUPINGS}
            sizes={{chart: 600, chartContainer: 625, chartXAxisFontSize: 12, wrapperStyle: { paddingTop: '40px' }}}
            xAxisProps={{interval: 0}}
            customBarTick={CustomizedAxisTickMultiLine}
          />
          <GenericProductFilterContainer clearFilters={() => setFilters({})}>
            <ProductDataFilter
              filterState={filters}
              applyFilter={applyFilter}
              dataFilterEndpoint={endpoints.UNDELIVERABLE_FILTERS}
            />
            <div className='grid grid-columns-2 grid-gap-5 mta'>
              { (hasPermission('UNDELIVERABLE', 'BULK-BUY')) ?
                  <button style={{  gridColumn: 'span 2' }} className="button bulk-buy-button compact smaller-text" onClick={() => setBulkModel('purchase')}>
                      Create Download File
                  </button>
              : '' }
              { (hasPermission('UNDELIVERABLE', 'ALLOCATE')) ?
                  <button style={{ gridColumn: !hasPermission('UNDELIVERABLE', 'UNALLOCATE') && 'span 2' }} 
                    className="button bulk-buy-button compact smaller-text" onClick={() => setBulkModel('allocate')}>
                      Allocate
                  </button>
              : '' }
              { (hasPermission('UNDELIVERABLE', 'UNALLOCATE')) ?
                  <button style={{ gridColumn: !hasPermission('UNDELIVERABLE', 'ALLOCATE') && 'span 2' }}
                   className="button bulk-buy-button compact smaller-text" onClick={() => setBulkModel('unallocate')}>
                      Unallocate
                  </button>
              : '' }
          </div>
          </GenericProductFilterContainer>
        </div>
      </GenericPageContainer>,
          <S3Modal
          closeModal={() => setS3Model(null)}
          modalMode={S3Model}
          showModal={!!S3Model}
          listingUrl={endpoints.UNDELIVERABLE_FILES}
          uploadUrl={endpoints.UNDELIVERABLE_FILES}
        />,
        <BulkBuy 
        SentenceFirst={({count}) => <>The selected data set includes {count} SPIDs to be downloaded. Press the 'Create File' button to create the download file and you will receive an email notification once this is available. Alternatively press the 'Cancel' button to go back to the summary screen.</>}
        SentenceSecond={() => <></>}
        purchaseLabel="Download Limit:"
        buyButtonText="Create File"
        completeOnFirstStep={true} 
        workflowUsersEndpoint={endpoints.UNDELIVERABLE_WF_USERS} 
        bulkEndpoint={endpoints.UNDELIVERABLE_BULK_BASE} 
        modalIsOpen={bulkModel === 'purchase'} 
        closeModal={() => setBulkModel('')} 
        filters={filters} 
        date={date} />,
        <BulkAllocate 
        workflowUsersEndpoint={endpoints.UNDELIVERABLE_WF_USERS} 
        bulkEndpoint={endpoints.UNDELIVERABLE_BULK_BASE} 
        unallocateEndpoint={endpoints.UNDELIVERABLE_UNALLOCATE} 
        modalIsOpen={bulkModel === 'allocate' || bulkModel === "unallocate"} 
        mode={bulkModel === "unallocate" ? "unallocate" : null}
        closeModal={() => setBulkModel('')} 
        filters={filters} 
        date={date} />,
    ];
});
